import axios from 'axios';
import {getUserToken, payStackSecretToken} from "../helpers/authenticator";

const BASEURL = "http://localhost/panache/api/v1/"; // TEST
// const BASEURL = "https://api.gozing.co/api/v1/";

let instance = axios;
instance.defaults.headers.common['Authorization'] = "Bearer " + getUserToken();
instance.defaults.headers.post['Content-Type'] = 'application/json';


const getRequestType = (method = "GET", basePath, relativePath, data, authorization) => {

    if (authorization) {
        instance.defaults.headers.common['Authorization'] = "Bearer " + payStackSecretToken();
    }

    switch (method) {
        case "GET":
            return instance.get(basePath + relativePath);
        case "POST":
            return instance.post(basePath + relativePath, data);
        case "PUT":
            return instance.put(basePath + relativePath, data);
        default:
            return instance.get(basePath + relativePath);
    }

};

const makeRequest = (method = "GET", path = "", baseUrl = "", data = {}, setAuthorization = false) => {
    baseUrl = baseUrl.length !== 0 ? baseUrl : BASEURL;
    return getRequestType(method, baseUrl, path, data, setAuthorization)
};

const requestMethods = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT"
};

export default {
    methods: requestMethods,
    makeRequest: makeRequest
};
